import { api } from './client.js';

/**
 * Real travel-time polygons via Valhalla on the Ghana OSM extract.
 * Replaces the old turf.circle approximation.
 */
export const isochrone = (payload) => api.post('/routing/isochrone', payload);
